export default __webpack_public_path__ + "fda3a3ad4d17715a8b555ad505988cd3.png";